import { MutationResult } from "@/api/utils/types"
import { useMutation } from "@/api/utils/useQuery"
import { HasuraMutations } from "@/api/hasura/mutations"
import { UpdateConfigurationsMutationVariables } from "@/api/hasura/generated/graphql"

export interface IConfigurationMutator {
  update(): MutationResult<UpdateConfigurationsMutationVariables>
}

export class ConfigurationMutatorClass implements IConfigurationMutator {
  update(): MutationResult<UpdateConfigurationsMutationVariables> {
    return useMutation({
      ...HasuraMutations.configurations.update(),
      serializerFn: (data) => data,
      invalidateCache: false,
    })
  }
}

export const ConfigurationMutator = new ConfigurationMutatorClass()
